<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning">
			<!-- <div class="row mb-2">
				<h5 class="bg-info p-2">Other</h5>
			</div> -->
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@change:value="getFromCities"
						@update:value="setFromCity"
						:options="multiSelectState.fromCitiesSelect"
						rules="required"
						name="From"
						:defaultData="data.fromCity?.id"
						mode="single"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@change:value="getToCities"
						@update:value="setToCity"
						:options="multiSelectState.toCitiesSelect"
						rules="required"
						name="To"
						mode="single"
						:defaultData="data.toCity?.id"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-3">
					<BaseInput
						name="Departure Date"
						label="Departure Date"
						type="date"
						:min="`${new Date().toISOString().split('T')[0]}`"
						v-model="data.departureDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseInput
						name="Return Date"
						label="Return Date"
						type="date"
						:min="
							data.departureDate
								? data.departureDate
								: `${new Date().toISOString().split('T')[0]}`
						"
						v-model="data.returnDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setClass"
						:options="multiSelectState.class"
						rules="required"
						name="Class"
						mode="single"
						:defaultData="data.class"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-3 my-2 d-flex align-items-center">
					<BaseRadio
						class="form-check-input m-0 custom-dark-text"
						labelClass="small text-muted"
						label="International Flight"
						id="internationalFlight"
						name="category"
						:checked="data.category === 'International Flight' ? true : false"
						v-model="data.category"
					/>
				</div>
				<div class="form-group col-sm-3 my-2 d-flex align-items-center">
					<BaseRadio
						class="form-check-input m-0 custom-dark-text"
						labelClass="small text-muted"
						label="Domestic Flight"
						id="domesticFlight"
						:checked="data.category === 'Domestic Flight' ? true : false"
						name="category"
						v-model="data.category"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseMultiSelect
						@update:value="setFlexibility"
						:options="multiSelectState.flexibility"
						rules="required"
						name="Flexibility"
						mode="single"
						:defaultData="data.flexibility"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseMultiSelect
						@update:value="setPreference"
						:options="multiSelectState.preferences"
						rules="required"
						name="Preferences"
						mode="single"
						:defaultData="data.preference"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch, inject } from "vue";
	import Helper from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseRadio from "./BaseRadio.vue";

	export default {
		name: "LeadFlightBooking",
		components: {
			BaseInput,
			BaseMultiSelect,
			BaseRadio,
		},
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Array, Object, String], default: "" },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const leadState = inject("leadState");

			const data = reactive({
				fromCity: {
					name: null,
					id: 0,
				},
				toCity: {
					name: null,
					id: 0,
				},
				departureDate: null,
				returnDate: null,
				class: null,
				category: [],
				flexibility: null,
				preference: null,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.fromCity.name &&
						data.toCity.name &&
						data.departureDate &&
						data.class
					) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				cities: [],
				fromCitiesSelect: [],
				toCitiesSelect: [],
				preferences: Helper.flightPreferences,
				class: Helper.flightClass,
				flexibility: Helper.flightFlexibility,
			});

			// ! City Functions

			const getCities = async (key, cityObj = false) => {
				let cityData = {};

				if (cityObj?.name && cityObj?.name.length < 3) return;
				if (cityObj?.name) cityData.name = cityObj.name;

				try {
					const cities = await Helper.getCities(cityData);

					multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						if (
							key === "toCitiesSelect" &&
							data.fromCity?.name &&
							data.fromCity.name === city.name
						)
							return;
						return {
							label: `${city.name} (${city.state_name}, ${city.country_name})`,
							value: city.id,
						};
					});

					multiSelectState[key] = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const getFromCities = (payload) => {
				getCities("fromCitiesSelect", payload);
			};
			const getToCities = (payload) => {
				getCities("toCitiesSelect", payload);
			};

			const setFromCity = (dataObj) => {
				setCity("fromCity", dataObj);
			};

			const setToCity = (dataObj) => {
				setCity("toCity", dataObj);
			};

			const setCity = (key, dataObj) => {
				if (!key) return;
				if (!dataObj) {
					data[key].id = 0;
					data[key].name = null;
					data[key].state_name = null;
					return;
				}

				// ? finding selected city data
				const city = multiSelectState.cities.filter(
					(city) => city?.id === dataObj,
				);

				data[key].id = city[0].id;
				data[key].name = city[0].name;
				data[key].state_name = city[0].state_name;
			};

			const setClass = (payload) => {
				data.class = payload;
			};
			const setPreference = (payload) => {
				data.preference = payload;
			};
			const setFlexibility = (payload) => {
				data.flexibility = payload;
			};

			if (
				props.defaultData instanceof Array ||
				props.defaultData instanceof Object
			) {
				let keys = Object.keys(data);
				keys.map((key) => (data[key] = props.defaultData[key] || data[key]));
				data.departureDate = props.defaultData?.departureDate.split("T")[0];
				data.returnDate = props.defaultData?.returnDate.split("T")[0];

				multiSelectState.cities = [
					...multiSelectState.cities,
					{
						id: props.defaultData?.fromCity.id,
						name: props.defaultData?.fromCity.name,
					},
					{
						id: props.defaultData?.toCity.id,
						name: props.defaultData?.toCity.name,
					},
				];
				multiSelectState.fromCitiesSelect = [
					...multiSelectState.fromCitiesSelect,
					{
						value: props.defaultData?.fromCity.id,
						label: props.defaultData?.fromCity.name,
					},
				];
				multiSelectState.toCitiesSelect = [
					...multiSelectState.toCitiesSelect,
					{
						value: props.defaultData?.toCity.id,
						label: props.defaultData?.toCity.name,
					},
				];
			}

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				getFromCities,
				getToCities,

				setFromCity,
				setToCity,
				setClass,
				setPreference,
				setFlexibility,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
